/** @jsxImportSource @emotion/react */
import { Theme, useTheme } from '@mui/material';
import CommonPageLayout from 'components/layouts/CommonPageLayout';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { UseStyles } from 'types/styles';

const PartnersPage: React.FC = () => {
  const theme = useTheme() as Theme;
  const classes = useStyles(theme);
  const { formatMessage } = useIntl();

  return (
    <CommonPageLayout>
      <Helmet>
        <title>{formatMessage({ id: 'pageTitle.partners', defaultMessage: 'Partners' })}</title>
      </Helmet>
      <div css={classes.PartnersPage}>Partners page</div>
    </CommonPageLayout>
  );
};

const useStyles = (theme: Theme): UseStyles => ({
  PartnersPage: {},
});

export default PartnersPage;
